<template>
    <div class="h-100" style="position:relative">
        <div v-if="target" class="overflow-scroll h-100">
            <div>
                <div v-if="srcTarget">
                    <h4>
                        {{srcTarget.name.replace("|", "")}}
                    </h4>
                    <p>
                        <span class="bi bi-file-earmark-text"></span>
                        {{srcTarget.document.name}}
                    </p>
                    <p class=""><span class="bi bi-bookmark-fill"></span>page.{{srcTarget.page + 1}}</p>
                    <p v-if="srcTarget.snippet">{{srcTarget.snippet}}</p>
                    <div class="container-fluid">
                        <span v-for="tag in tags" :key="tag" class="badge bg-primary m-1">{{ tag }}</span>
                    </div>
                    <div>
                        <div class="footer">
                            <div class="input-group" v-if="showMode==='src'">
                                <a class="btn btn-primary text-white me-1" :href="anchorUrl(srcTarget)">開く</a>
                                <a class="btn btn-primary text-white" :target="srcTarget.document.name" :href="anchorUrl(srcTarget)">タブで開く</a>
                            </div>
                            <div class="input-group" v-else>
                                <button class="btn btn-primary me-1" @click="showAnchorEditDialog"><i class="bi bi-pencil"></i>編集</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <ul class="list-group" v-if="target.src_hyperlinks.length > 0">
                        <h6>リンク一覧</h6>
                        <li v-for="link in target.src_hyperlinks" :key="link.src_anchor.id" class="list-group-item">
                            <a href="javascript:void()" @click.prevent.stop="resetTarget(link.src_anchor);">
                                <i class="bi bi-box-arrow-up-right"></i>
                                <span>{{link.src_anchor.document.name}}</span> <span>p.{{link.src_anchor.page + 1}}</span>
                            </a>
                        </li>
                    </ul>
                    <div v-else>この場所へのリンクはありません</div>
                </div>
                <div class="bi bi-caret-down mx-auto text-center" style="font-size: 3rem;"></div>

                <div v-if="dstTarget">
                    <h4>
                        {{dstTarget.name.replace("|", "")}}
                    </h4>
                    <h5>
                        <span class="bi bi-file-earmark-text"></span>
                        {{dstTarget.document.name}}
                    </h5>
                    <p class=""><span class="bi bi-bookmark-fill"></span>page.{{dstTarget.page + 1}}</p>
                    <p v-if="dstTarget.snippet">{{dstTarget.snippet}}</p>
                    <div class="container-fluid">
                        <span v-for="tag in tags" :key="tag" class="badge bg-primary m-1">{{ tag }}</span>
                    </div>
                    <div class="footer">
                        <div class="input-group" v-if="showMode==='src'">
                            <a class="btn btn-primary text-white ms-1" @click="showAnchorEditDialog"><i class="bi bi-pencil"></i>編集</a>
                        </div>
                        <div class="input-group" v-else>
                            <a class="btn btn-primary text-white me-1" :href="anchorUrl(dstTarget)">開く</a>
                            <a class="btn btn-primary text-white" :target="dstTarget.document.name" :href="anchorUrl(dstTarget)">タブで開く</a>
                        </div>
                    </div>
                </div>
                <div v-else>
                    リンク先が見つかりません。
                </div>
            </div>
            <PdfPane
                    v-if="showPdf"
                    :bucketname="bucketname"
                    :openInfo="openInfo"
                    :displayOnly="true"
                    :anchors="[]"
                    />
        </div>
        <div class="footer position-absolute bottom-0 w-100">
            <div class="input-group">
                <button class="btn btn-secondary me-1 w-100" @click="prev" v-if="prevTargetId"><i class="bi bi-arrow-left"></i></button>
                <button class="btn btn-secondary me-1 w-100" @click="close" v-else><i class="bi bi-x-lg"></i></button>
            </div>
        </div>
        <div class="modal fade" id="anchorEditDialog" ref="anchorEditDialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content p-3">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">アンカー情報</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <h5>参照名称</h5>
                        <input type="text" class="form-control" v-model="anchorEditName" />
                        <!--
                        <h5>タグ</h5>
                        <input type="text" class="form-control" v-model="anchorEditTag" />
                        -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="onAnchorEdit">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PdfPane from "./PdfPane.vue";
import utils from "../utils/utils.js";
import {Modal} from 'bootstrap'

export default {
    name: "AnchorDetail",
    components: {PdfPane},
    props: {
        bucketname: { type: String, required: true},
        showMode: { type: String, required: true},
        target: { type: Object, required: true},//false, default: null},
    },
    data: function() {
        return {
            openInfo: {obj: '', page: 0},
            labels: [],
            tags: [],
            prevTargetId: 0,
            mode: 'view',
            documents: [],
            newDestAnchor: 0,
            showPdf: false,
            anchorEditName: '',
            anchorEditTag: '',
        };
    },
    methods: {
        close(){
            this.$emit('src-selected', 0);
        },
        anchorUrl: function(anchor) {
            return `/?case=${anchor.document.lawcase.id}&obj=${encodeURI(anchor.document.lawcase.path_prefix + '/' + anchor.file.path)}&page=${anchor.page+1}`;
        },
        resetTarget: function(anchor) {
            console.log("RESET TARGET to " + anchor.id + " " + this.showMode);
            this.prevTargetId = this.target.id;
            this.$emit('src-selected', anchor.id);
        },
        prev: function() {
            if(this.prevTargetId){
                this.$emit('src-selected', this.prevTargetId);
                this.prevTargetId = 0;
            }else{
                console.log("******");
            }
        },
        /*
        async updateDocuments(){
            this.chapterListDialogLoading = true;
            try{
                console.log("updating documents -- " + this.target.document.lawcase.id);
                if(!this.target.document.lawcase.id){ this.documents = []; }
                else {
                    let gql = `{document(where: {lawcase_id: {_eq: ${this.target.document.lawcase.id}}}){id, name, document_type {name}, file {path}, lawcase { path_prefix}, start_page,}}`
                    let res = await utils.queryGQL(gql);
                    this.documents = res['document'];
                }
            } finally {
                this.chapterListDialogLoading = false;
            }
        },*/
        chapterChanged(id){
            this.newDestAnchor = Number(id);
        },
        async onAnchorEdit() {
            if(this.target){
                let d = {'document_id': this.target.document.id};
                if(this.anchorEditName){
                    d.name = this.anchorEditName;
                }
                if(this.anchorEditTag){
                    d.tag = this.anchorEditName;
                }
                await utils.put(`/api/anchor/${this.target.id}`, d);
                this.$emit('src-selected', 0);
                this.$emit('update-anchors');
            } else {
                throw "対象が存在しません。";
            }
        },
        showAnchorEditDialog(){
            console.log(this.target);
            this.anchorEditName = this.target.name;
            this.anchorEditTag = this.target.tag;
            this.anchorEditDialog.show();
        }
    },
    mounted: function(){
        this.anchorEditDialog = new Modal(this.$refs.anchorEditDialog);
    },
    watch: {
        target: function(t){
            if(t){
                if(this.showMode == 'dst'){
                    t = (t.dst_hyperlinks.length > 0) ? t.dst_hyperlinks[0].dst_anchor : null;
                } else {
                    t = t.is_reference ? t : null
                }
            }
            this.showPdf = Boolean(t);
            this.$nextTick( () => {
                if(t) { 
                    this.openInfo = {
                        obj: t.document.lawcase.path_prefix + "/" + t.file.path,
                        page: t.page + 1
                    };
                } else {
                    this.openInfo = { obj:null, page: 0};
                }
                console.log("CHANGE OPEN INFO" + this.openInfo);
            });
            console.log(this.openInfo);
        },
    },
    computed: {
        srcTarget: function(){
            return this.target.is_reference ? this.target : null;
        },
        dstTarget: function(){
            if(!this.target.is_reference){
                return this.target;
            }
            return this.target.dst_hyperlinks.length > 0 ? this.target.dst_hyperlinks[0].dst_anchor : null;
        },
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
